export default __webpack_public_path__ + "static/media/shape4.f310ecf0.svg";